import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window | null>('WINDOW_REF', {
  providedIn: 'root',
  factory: () => (typeof window !== 'undefined' ? window : null),
});
